import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({

  templateUrl: 'not-ready-room.component.html',

  
})
export class NotReadyRoomComponent implements OnInit {
  sub
  constructor(public route: ActivatedRoute){}
  startsAt
  after = false;
  before = false
  ngOnInit() {
    //  this.boards[0] = { wbType: "WELCOME" };
    /*var self = this;
    this.sub = this.route.params.subscribe(params => {
      console.log("Got time ", params)
     
      if (params['time']) {
        let userHash = params['userHash']
        let time = params['time']
        let m = moment(time, "x");
        self.startsAt = m.format("DD.MM.YYYY HH:mm");
       
     
        self.before = m.isBefore(moment());
        self.after = !self.before;
        if (self.after){
          setTimeout(function(){
            window.location.href = "#/wb/" + userHash;
          },3000)
        }
      }
      
    });*/
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/not-ready-room.component.ts